import { combineReducers } from 'redux'

import resultados from './detalhesRecursoConcedido'
import aditivosRecursoConcedido from './aditivosRecursoConcedido'
import administradorPublicoRecursoConcedido from './administradorPublicoRecursoConcedido'
import controleInternoRecursoConcedido from './controleInternoRecursoConcedido'
import cronogramaDesembolsoRecursoConcedido from './cronogramaDesembolsoRecursoConcedido'
import parecerComissaoRecursoConcedido from './parecerComissaoRecursoConcedido'
import parecerGestorRecursoConcedido from './parecerGestorRecursoConcedido'
import planoTrabalhoRecursoConcedido from './planoTrabalhoRecursoConcedido'
import resumoPrestacaoRecursoConcedido from './resumoPrestacaoRecursoConcedido'
import empenhoRecursoConcedido from './empenhoRecursoConcedido'
import convenentesConcedentesConcedido from './convenentesConcedentes'

export default combineReducers({
    resultados,
    aditivosRecursoConcedido,
    administradorPublicoRecursoConcedido,
    controleInternoRecursoConcedido,
    cronogramaDesembolsoRecursoConcedido,
    parecerComissaoRecursoConcedido,
    parecerGestorRecursoConcedido,
    planoTrabalhoRecursoConcedido,
    resumoPrestacaoRecursoConcedido,
    empenhoRecursoConcedido,
    convenentesConcedentesConcedido,
})
